import ServiceModelMap from '@/router/modules/ServiceModelMap/ServiceModelMap';
import NationalRiskManager from '@/router/modules/NationalRiskManager/NationalRiskManager';
import EmergencyResponsePlan from "@/router/modules/EmergencyResponsePlan/EmergencyResponsePlan";
import EmergencyResponsePlanDetails from "@/router/modules/EmergencyResponsePlanDetails/EmergencyResponsePlanDetails";
import EmergencyScenario from "@/router/modules/EmergencyScenario/EmergencyScenario";
import EmergencyDrill from "@/router/modules/EmergencyDrill/EmergencyDrill";
import CriseType from "@/router/modules/CriseType/CriseType";
import ExportTemplate from "@/router/modules/ExportTemplate/ExportTemplate";
import EmergencyEquipment from "@/router/modules/EmergencyEquipment/EmergencyEquipment";
import DrillType from "@/router/modules/DrillType/DrillType";
import EmergencyEquipmentType from "@/router/modules/EmergencyEquipmentType/EmergencyEquipmentType";
import ThirdPartyContract from "@/router/modules/ThirdPartyContract/ThirdPartyContract";
import ThirdPartyRequestSetting from "@/router/modules/ThirdPartyRequestSetting/ThirdPartyRequestSetting";
import ThirdPartyEvaluation from "@/router/modules/ThirdPartyEvaluation/ThirdPartyEvaluation";
import ThirdPartyAssessmentAnswer from "@/router/modules/ThirdPartyAssessmentAnswer/ThirdPartyAssessmentAnswer";
import Question from "@/router/modules/Question/Question";


import Assessment from "@/router/modules/Assessment/Assessment";
import AssessmentTemplate from "@/router/modules/AssessmentTemplate/AssessmentTemplate";
import AssessmentsResults from "@/router/modules/AssessmentsResults/AssessmentsResults";
import ThirdPartyRisk from "@/router/modules/ThirdPartyRisk/ThirdPartyRisk";
import ThirdPartyAssessmentResult from "@/router/modules/ThirdPartyAssessmentResult/ThirdPartyAssessmentResult";
import ThirdPartyAssessment from "@/router/modules/ThirdPartyAssessment/ThirdPartyAssessment";
import ThirdPartyService from "@/router/modules/ThirdPartyService/ThirdPartyService";
import ThirdPartyRequest from "@/router/modules/ThirdPartyRequest/ThirdPartyRequest";
import ThirdPartyClassification from "@/router/modules/ThirdPartyClassification/ThirdPartyClassification";
// import ThirdPartyVendorRepositorySubsidiary from "@/router/modules/ThirdPartyVendorRepositorySubsidiary/ThirdPartyVendorRepositorySubsidiary";
// import ThirdPartyVendorRepositoryEntity from "@/router/modules/ThirdPartyVendorRepositoryEntity/ThirdPartyVendorRepositoryEntity";
import ThirdPartyVendorRepositoryContact from "@/router/modules/ThirdPartyVendorRepositoryContact/ThirdPartyVendorRepositoryContact";
import VendorRepository from "@/router/modules/VendorRepository/VendorRepository";
import ThirdPartyContractType from "@/router/modules/ThirdPartyContractType/ThirdPartyContractType";
// End Third Party Module

import DisasterRecoveryPlanSite from "@/router/modules/DisasterRecoveryPlanSite/DisasterRecoveryPlanSite";
import EscalationAction from "@/router/modules/EscalationAction/EscalationAction";
import Escalation from "@/router/modules/Escalation/Escalation";
import EscalationRule from "@/router/modules/EscalationRule/EscalationRule";
import Effectiveness from "@/router/modules/Effectiveness/Effectiveness";
import InternalMessage from "@/router/modules/InternalMessage/InternalMessage";
import DisasterRecoveryPlan from "@/router/modules/DisasterRecoveryPlan/DisasterRecoveryPlan";
import Task from "@/router/modules/StrategicPlan/Task/Task";
import Deliverable from "@/router/modules/StrategicPlan/Deliverable/Deliverable";
import StrategicPlan from "@/router/modules/StrategicPlan/StrategicPlan";
import StrategicPlanDetails from "@/router/modules/StrategicPlan/StrategicPlanDetails/StrategicPlanDetails";
import Program from "@/router/modules/StrategicPlan/Program/Program";
import ObjectiveDetails from "@/router/modules/StrategicPlan/ObjectiveDetails/ObjectiveDetails";
import InitiativeDetails from "@/router/modules/StrategicPlan/InitiativeDetails/InitiativeDetails";
import DeliverableDetails from "@/router/modules/StrategicPlan/DeliverableDetails/DeliverableDetails";
import TaskDetails from "@/router/modules/StrategicPlan/TaskDetails/TaskDetails";
import ProgramDetails from "@/router/modules/StrategicPlan/ProgramDetails/ProgramDetails";
import Objective from "@/router/modules/StrategicPlan/Objective/Objective";
import ObjectiveType from "@/router/modules/StrategicPlan/ObjectiveType/ObjectiveType";
import Initiative from "@/router/modules/StrategicPlan/Initiative/Initiative";
import Project from "@/router/modules/StrategicPlan/Project/Project";
import ProjectDetails from "@/router/modules/StrategicPlan/ProjectDetails/ProjectDetails";
import Milestone from "@/router/modules/StrategicPlan/Milestone/Milestone";
import MilestoneDetails from "@/router/modules/StrategicPlan/MilestoneDetails/MilestoneDetails";
import Krisubmission from "@/router/modules/Krisubmission/Krisubmission";
import Kri from "@/router/modules/Kri/Kri";
import Tag from "@/router/modules/Tag/Tag";

import Kriformulavariable from "@/router/modules/Kriformulavariable/Kriformulavariable";
// Base Vue Router configuration for the E-GRC application
import BIAAdminManager from "@/router/modules/BIAAdminManager/BIAAdminManager";
import BIADepartment from "@/router/modules/BIADepartment/BIADepartment";
import DisruptionImpact from "@/router/modules/DisruptionImpact/DisruptionImpact";
import BIAImpactMatrix from "@/router/modules/BIAImpactMatrix/BIAImpactMatrix";
import BusinessContinuityPlan from "@/router/modules/BusinessContinuityPlan/BusinessContinuityPlan";
// Risk Modules
import RiskTaxonomy from "@/router/modules/RiskTaxonomy/RiskTaxonomy";
import Risk from "@/router/modules/Risk/Risk";
import RiskFunction from "@/router/modules/RiskFunction/RiskFunction";
import RiskDepartmentManagement from '@/router/modules/RiskDepartmentManagement/RiskDepartmentManagement';
import ThreatCatalog from "@/router/modules/ThreatCatalog/ThreatCatalog";
import threatGroup from "@/router/modules/threatGroup/threatGroup";
import RiskCatalog from "@/router/modules/RiskCatalog/RiskCatalog";
import GroupRisk from "@/router/modules/GroupRisk/GroupRisk";
import RiskMitigationEffort from "@/router/modules/RiskMitigationEffort/RiskMitigationEffort";
import RiskCategory from "@/router/modules/RiskCategory/RiskCategory";
import Vulnerability from "@/router/modules/Vulnerability/Vulnerability";
import RiskSource from "@/router/modules/RiskSource/RiskSource";
import AssetGroup from "@/router/modules/AssetGroup/AssetGroup";
import Asset from "@/router/modules/Asset/Asset";
import assetCategory from "@/router/modules/AssetCategory/AssetCategory";
import AssetValuation from "@/router/modules/AssetValuation/AssetValuation";
import AssetEnvironmentCategory from "@/router/modules/AssetEnvironmentCategory/AssetEnvironmentCategory";
import AssetValueQuestion from "@/router/modules/AssetValueQuestion/AssetValueQuestion";
import assetValueLevel from "@/router/modules/assetValueLevel/assetValueLevel";
import operatingSystem from "@/router/modules/OperatingSystem/OperatingSystem";
import hostRegion from "@/router/modules/hostRegion/hostRegion";
import Exception from "@/router/modules/Exception/Exception";
import ExceptionSetting from "@/router/modules/ExceptionSetting/ExceptionSetting";
import KpiModule from "@/modules/kpi";
import Kriunit from "@/router/modules/Kriunit/Kriunit";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import BodyView from "@/layout/bodyView.vue";
import indexDashboard from "@/pages/indexDashboard.vue";

// User & Auth Routes
import User from "@/router/modules/User/User";
import AuthRoute from "@/router/modules/Auth/Auth";
import Permission from "@/router/modules/Permission/Permission";
import Auth from "@/API/Auth";
import { hasPermission } from "@/utils/helpers";
import Dashboard from "@/router/modules/Dashboard/Dashboard";
import GeneralRelation from "@/router/modules/GeneralRelation/GeneralRelation";
// Job & Department
import Job from "@/router/modules/Job/Job";
import Department from "@/router/modules/Department/Department";
import Hierarchy from "@/router/modules/Hierarchy/Hierarchy";
import Role from "@/router/modules/Role/Role";
import Position from "@/router/modules/Position/Position";
import Team from "@/router/modules/Team/Team";
import Color from "@/router/modules/Color/Color";
import RiskLevel from "@/router/modules/RiskLevel/RiskLevel";

import EmailConfig from "@/router/modules/EmailConfig/EmailConfig";
import Log from "@/router/modules/Log/Log";
import LogSetting from "@/router/modules/LogSetting/LogSetting";
import NotificationSetting from "@/router/modules/NotificationSetting/NotificationSetting";
import Notification from "@/router/modules/notification/notification";
import AllNotification from "./modules/AllNotification/AllNotification";
import Cookies from "js-cookie";
import Errors from "./modules/Errors/Errors";
import Language from "@/router/modules/Language/Language";
import Translate from "@/router/modules/Translate/Translate";
import Location from "@/router/modules/Location/Location";
import BusinessContinuitySetting from "@/router/modules/BusinessContinuitySetting/BusinessContinuitySetting";
import GeneralTask from "@/router/modules/GeneralTask/GeneralTask";
import Category from "@/router/modules/Category/Category";
import NationalRiskIdentification from "@/router/modules/NationalRiskIdentification/NationalRiskIdentification";

// START National Risk
import RiskAffectedParty from "@/router/modules/RiskAffectedParty/RiskAffectedParty";
import RiskZone from "@/router/modules/RiskZone/RiskZone";
import NationalRiskDetection from "@/router/modules/NationalRiskDetection/NationalRiskDetection";
import NationalRiskThreat from "@/router/modules/NationalRiskThreat/NationalRiskThreat";
import NationalRiskVulnerability from "@/router/modules/NationalRiskVulnerability/NationalRiskVulnerability";
import WarningPotentialImpactMatrix from "@/router/modules/WarningPotentialImpactMatrix/WarningPotentialImpactMatrix";
import NationalRiskWarning from "@/router/modules/NationalRiskWarning/NationalRiskWarning";
import NationalRiskPrioritization from "@/router/modules/NationalRiskPrioritization/NationalRiskPrioritization";
import PreventionProgram from "@/router/modules/PreventionProgram/PreventionProgram";
import Sector from "@/router/modules/Sector/Sector";
import PreventionMeasure from "@/router/modules/PreventionMeasure/PreventionMeasure";
import MeasureClassification from "@/router/modules/MeasureClassification/MeasureClassification";
import InfrastructureResilience from "@/router/modules/InfrastructureResilience/InfrastructureResilience";
// END National Risk

//Site Module
import SiteType from "@/router/modules/SiteType/SiteType";
import Site from "@/router/modules/Site/Site";
import CrisisManagement from "@/router/modules/CrisisManagement/CrisisManagement";

//Committee Modules
import Topic from "@/router/modules/Topic/Topic";
import Committee from "@/router/modules/Committee/Committee";
import AgendaDetails from "@/router/modules/AgendaDetails/AgendaDetails";
import Meeting from "@/router/modules/Meeting/Meeting";
import TopicRecommendation from "@/router/modules/TopicRecommendation/TopicRecommendation";

// document and workflow and compliance modules can be added here
import FrameworkInstall from "@/router/modules/FrameworkInstall/FrameworkInstall";
import InternalAuditResult from "@/router/modules/InternalAuditResult/InternalAuditResult";
import InternalAudit from "@/router/modules/InternalAudit/InternalAudit";
import ControlClass from "@/router/modules/ControlClass/ControlClass";
import ControlPhase from "@/router/modules/ControlPhase/ControlPhase";
import AuditPolicyCompliance from "@/router/modules/AuditPolicyCompliance/AuditPolicyCompliance";
import CenterPolicy from "@/router/modules/CenterPolicy/CenterPolicy";
import Document from "@/router/modules/Document/Document";
import DocumentCategory from "@/router/modules/DocumentCategory/DocumentCategory";
import WorkflowCategory from "@/router/modules/WorkflowCategory/WorkflowCategory";
import Regulator from "@/router/modules/Regulator/Regulator";
import Control from "@/router/modules/Control/Control";
import ControlType from "@/router/modules/ControlType/ControlType";
import Domain from "@/router/modules/Domain/Domain";
import Requirement from "@/router/modules/Requirement/Requirement";
import Maturity from "@/router/modules/Maturity/Maturity";
import RiskControlType from "@/router/modules/RiskControlType/RiskControlType";
import Frameworks from "@/router/modules/Frameworks/Frameworks";
import Evidence from "@/router/modules/Evidence/Evidence";
import AuditRemidation from "@/router/modules/AuditRemidation/AuditRemidation";
import FrameworkControlTestAudit from "@/router/modules/FrameworkControlTestAudit/FrameworkControlTestAudit";
import AuditPlan from "@/router/modules/AuditPlan/AuditPlan";
import MyWorks from "@/router/modules/MyWorks/MyWorks";
import UserReport from "@/router/modules/UserReport/UserReport";
import Process from "@/router/modules/Process/Process";
// import CrisisTask from "@/router/modules/CrisisTask/CrisisTask";
import { useTranslations } from "@/composables/useTranslations";

declare const APP_NAME: string;

declare global {
  interface Window {
    routerData?: string;
  }
}

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: BodyView,
    meta: {
      title: "Default |  ",
    },
    children: [
      // ...CrisisTask,
      ...Process,
      {
        path: "/",
        redirect: { name: "Dashboard" },
      },
      ...Permission,
      ...User,
      ...Job,
      ...Department,
      ...Hierarchy,
      ...Role,
      ...Team,
      ...Position,
      ...Color,
      ...NotificationSetting,
      ...Notification,
      ...AllNotification,
      ...LogSetting,
      ...Log,
      ...EmailConfig,
      // RISK MODULES
      ...RiskTaxonomy,
      ...Risk,
      ...RiskFunction,
      ...GroupRisk,
      ...ThreatCatalog,
      ...threatGroup,
      ...RiskMitigationEffort,
      ...RiskCategory,
      ...Vulnerability,
      ...AssetGroup,
      ...Asset,
      ...RiskLevel,
      ...GeneralTask,
      ...Category,
      ...RiskSource,
      ...assetCategory,
      ...AssetValuation,
      ...AssetEnvironmentCategory,
      ...AssetValueQuestion,
      ...assetValueLevel,
      ...operatingSystem,
      ...hostRegion,

      // EGRC SERVICE
      ...BIAAdminManager,
      ...BIADepartment,
      ...DisruptionImpact,
      ...BIAImpactMatrix,
      ...BusinessContinuityPlan,
      ...Language,
      ...Translate,
      ...Kriunit,
      ...Kri,
      ...Kriformulavariable,
      ...Krisubmission,

      ...ObjectiveType,
      ...Objective,
      ...StrategicPlan,
      ...StrategicPlanDetails,
      ...ObjectiveDetails,
      ...Program,
      ...Initiative,
      ...ProgramDetails,
      ...Deliverable,
      ...DeliverableDetails,
      ...Task,
      ...TaskDetails,
      ...Project,
      ...ProjectDetails,
      ...Milestone,
      ...MilestoneDetails,
      ...InitiativeDetails,
      ...Tag,
      ...InternalMessage,
      ...Location,
      ...BusinessContinuitySetting,
      ...DisasterRecoveryPlan,
      ...RiskControlType,
      ...Effectiveness,
      ...DisasterRecoveryPlanSite,
      ...RiskCatalog,
      ...Escalation,
      ...EscalationAction,
      ...EscalationRule,
      ...NationalRiskIdentification,

      // START National Risk
      ...RiskAffectedParty,
      ...RiskZone,
      ...NationalRiskDetection,
      ...NationalRiskThreat,
      ...NationalRiskVulnerability,
      ...WarningPotentialImpactMatrix,
      ...NationalRiskWarning,
      ...NationalRiskPrioritization,
      ...PreventionProgram,
      ...Sector,
      ...PreventionMeasure,
      ...MeasureClassification,
      ...InfrastructureResilience,
      ...NationalRiskManager,
      // END National Risk

      // Start Third Party Module
      ...VendorRepository,
      ...ThirdPartyVendorRepositoryContact,
      // ...ThirdPartyVendorRepositoryEntity,
      // ...ThirdPartyVendorRepositorySubsidiary,
      ...ThirdPartyClassification,
      ...ThirdPartyRequest,
      ...ThirdPartyService,
      ...ThirdPartyAssessment,
      ...ThirdPartyAssessmentResult,
      ...ThirdPartyRisk,
      ...Assessment,
      ...AssessmentTemplate,
      ...AssessmentsResults,
      ...Question,
      ...ExceptionSetting,
      ...Exception,
      ...ThirdPartyEvaluation,
      ...ThirdPartyRequestSetting,
      ...ThirdPartyContract,
      ...ThirdPartyContractType,
      // End Third Party Module

      //start Site Module
      ...SiteType,
      ...Site,
      //end Site Module
      //Committee Modules
      ...Topic,
      ...Committee,
      ...AgendaDetails,
      ...Meeting,
      ...TopicRecommendation,
      ...Dashboard,
      ...EmergencyEquipmentType,
      ...EmergencyEquipment,
      ...GeneralRelation,

      //Drill Module
      ...DrillType,

      //Crise Module
      ...CriseType,
      ...EmergencyDrill,
      ...CrisisManagement,
      ...EmergencyResponsePlan,
      ...EmergencyResponsePlanDetails,
      ...EmergencyScenario,

      ...Document,
      ...DocumentCategory,
      ...WorkflowCategory,
      ...FrameworkInstall,
      ...Regulator,
      ...Frameworks,
      ...Control,
      ...Domain,
      ...Regulator,
      ...Domain,
      ...FrameworkInstall,
      ...Frameworks,
      ...Control,
      ...ControlType,
      ...Requirement,
      ...Maturity,
      ...Evidence,
      ...AuditPlan,
      ...FrameworkControlTestAudit,
      ...AuditRemidation,
      ...CenterPolicy,
      ...AuditPolicyCompliance,
      ...ControlPhase,
      ...InternalAudit,
      ...MyWorks,
      ...UserReport,
      ...ExportTemplate,
      ...RiskDepartmentManagement,

      //----------
      ...KpiModule.routes,
      ...ServiceModelMap,
    ],
  },
  ...AuthRoute,
  ...Errors,
  ...ThirdPartyAssessmentAnswer,
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// Utility functions
function getCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
}

function base64UrlDecode(base64Url: string): string {
  let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const padding = base64.length % 4;
  if (padding) {
    base64 += "=".repeat(4 - padding);
  }
  return atob(base64);
}

function decodeJWT(token: string) {
  const parts = token.split(".");
  if (parts.length !== 3) {
    throw new Error("Invalid JWT format");
  }
  const header = JSON.parse(base64UrlDecode(parts[0]));
  const payload = JSON.parse(base64UrlDecode(parts[1]));
  return { header, payload };
}

// Function to get JWT token from cookies
function getTokenFromCookies(): string {
  let token = "";
  let i = 0;
  while (Cookies.get(`${APP_NAME}_api_token_part${i + 1}`)) {
    token += Cookies.get(`${APP_NAME}_api_token_part${i + 1}`);
    i++;
  }
  return token;
}


// Load translations before each route if mainTrKeys meta is present
// const SHARED_MODULES = ["common", "datatable", "menu"];

// router.beforeEach(async (to, from, next) => {
//   const modules: any = to.meta.mainTrKeys || [];

//   if (modules?.length == 0) {
//     const routeName: any = to?.name?.toString()?.toLocaleLowerCase();
//     //if the name is committe Details , delete the Details part
//     const mainKey = routeName.replace("details", "");
//     modules.push(mainKey);
//   }
//   // Always include shared modules
//   modules.push(...SHARED_MODULES);
//   if (modules && modules.length > 0) {
//     try {
//       const { loadMultipleModules } = useTranslations();
//       await loadMultipleModules(modules);
//     } catch (error) {
//       console.error("Failed to load translations:", error);
//     }
//   }

//   next();
// });


// Routes that don't require authentication
const publicRoutes = [
  "Login",
  "ForgotPassword",
  "ThirdPartyAssessmentAnswer",
  // "home",
  // "Home"
];

// Main authentication guard
router.beforeEach(async (to, from, next) => {
  try {
    // Skip authentication for routes marked with requiresAuth: false
    if (
      to.matched.some(
        (record) => record.meta && record.meta.requiresAuth === false
      )
    ) {
      return next();
    }

    // Check if user is authenticated
    const isAuthenticated = await Auth.loggedIn();

    if (
      isAuthenticated &&
      (to.name === "Login" || to.name === "ForgotPassword")
    ) {
      return next({ name: "home" });
    }

    // Allow public routes without authentication
    if (publicRoutes.includes(to.name as string)) {
      return next();
    }

    if (!isAuthenticated) {
      console.log("User not authenticated, redirecting to login");
      return next({ name: "Login" });
    }

    // Build controller path from route
    if (to.matched && to.matched.length > 1) {
      const component = to.matched[1];
      if (component && component.name && typeof component.name === "string") {
        const convertedPath = component.name
          .replace("/", "")
          .split("/")
          .map((part: string) => part.charAt(0).toUpperCase() + part.slice(1))
          .join("\\")
          .split("\\:id")
          .join("");

        // Extract the base module name from the route path for permission checking.
        // Detail/child routes like /risk/:id (name: "RiskView") should check the
        // base module "Risk", not "RiskView". We use the first path segment after "/".
        // Kebab-case paths (e.g. "third-party-profile") are converted to PascalCase ("ThirdPartyProfile").
        const pathSegments = (component.path || "").replace(/^\//, "").split("/").filter(Boolean);
        const baseModule = pathSegments.length > 0
          ? pathSegments[0]
            .split("-")
            .map((seg: string) => seg.charAt(0).toUpperCase() + seg.slice(1))
            .join("")
          : convertedPath;

        // Always set routerData to the base module controller for permission checks
        window.routerData = baseModule + "\\" + baseModule + "Controller\\";

        // Super admin has access to all routes
        if (Auth.isSuperAdmin()) {
          return next();
        }

        // Regular user - check permissions using role-based approach
        // 1) Check meta.permission if defined (supports "Model.action" format)
        const metaPerm = to.meta?.permission as string | undefined;
        if (metaPerm) {
          if (metaPerm.includes('.')) {
            const [model, action] = metaPerm.split('.');
            if (hasPermission(model, action || 'show')) {
              return next();
            }
          } else if (hasPermission(metaPerm, 'show')) {
            return next();
          }
          return next({ name: 'NotAuthorized' });
        }

        // 2) Try the base module first (e.g. "Risk" for /risk/:id),
        // then fall back to the full convertedPath (e.g. "RiskView")
        if (hasPermission(baseModule, "show") || hasPermission(convertedPath, "show")) {
          return next();
        } else {
          console.log("User does not have required permissions");
          return next({ name: "NotAuthorized" });
        }
      } else {
        return next({ name: "NotFound" });
      }
    } else {
      return next({ name: "NotFound" });
    }
  } catch (error) {
    console.error("Router guard error:", error);
    return next({ name: "Login" });
  }
});

// Update document title based on route meta
router.beforeEach((to) => {
  if (typeof to.meta?.title === "string") {
    document.title = to.meta.title;
  }
});


export default router;
